export default __webpack_public_path__ + "static/media/spa-image-04.07ba1788.jpg";